const initialState = {
    options:[]
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "supplier":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "supplier",
    reducer: reducer,
};

export default data;
